/**
 * Client-side gate deciding whether an inbound message is worth asking the backend
 * to extract tour availability from. A message with no scheduling signal never hits
 * the endpoint (and never spends an LLM extraction).
 *
 * This MUST stay in sync with the backend gate (the source of truth), in
 * reffie-backend `reffie/services/tours/availability_gate.py`.
 */

const GATE_MAX_LEN = 500;

const SCHEDULING_SIGNAL =
    /\b(?:today|tomorrow|tonight|morning|afternoon|evening|weekday|weekend|monday|tuesday|wednesday|thursday|friday|saturday|sunday|mon|tue|tues|wed|thu|thur|thurs|fri|sat|sun|anytime|whenever|after|before|between|around|at\s+\d|\d{1,2}(?::\d{2})?\s*(?:a\.?m\.?|p\.?m\.?)|book|schedule|tour|showing|viewing|come\s+by|see\s+(?:it|the\s+place))\b/i;

export const passesAvailabilityGate = (contents: string): boolean =>
    contents.length <= GATE_MAX_LEN && SCHEDULING_SIGNAL.test(contents);
